module.exports = __webpack_public_path__ + "img/滤镜粉夏.1d81700e.png";